import React from 'react';
import PropTypes from 'prop-types';

import Teaser from './Teaser';

function List(props) {
  const {
    items,
    pageOffset,
    pageSize,
    basePath,
    newItems,
  } = props;
  let list = null;
  if (items.length) {
    const listItems = [];
    const lastItem = (pageOffset + 1) * pageSize <= items.length
      ? (pageOffset + 1) * pageSize : items.length;
    for (let i = pageOffset * pageSize; i < lastItem; i += 1) {
      listItems.push((
        <li className="technical-services-list__item" key={items[i].publicId}>
          <Teaser
            title={items[i].title}
            institution={items[i].tags[0]}
            sector={items[i].tags[1]}
            uuid={items[i].publicId}
            basePath={basePath}
            isNew={newItems.indexOf(items[i].publicId) !== -1}
          />
        </li>
      ));
    }
    list = (
      <div className="technical-services-list">
        <h2 className="technical-services-list__title">Resultados</h2>
        <ul className="technical-services-list__list">
          {listItems}
        </ul>
      </div>
    );
  }
  const noResults = !items.length ? (
    <div className="view-alert">
      <div className="view-alert-content">
        <div className="svgicon-default">
          <svg viewBox="0 0 500 500">
            <use
              xlinkHref="/themes/custom/particle/dist/assets/spritemap.svg?cacheBuster=#sprite-alert"
            />
          </svg>
        </div>
        <p>
          No hay ningún resultado con los filtros seleccionados.
          Puede elegir otro filtro para buscar.
        </p>
      </div>
    </div>
  ) : null;
  return (
    <div>
      {list}
      {noResults}
    </div>
  );
}

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  pageOffset: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  basePath: PropTypes.string.isRequired,
  newItems: PropTypes.arrayOf(PropTypes.string),
};

List.defaultProps = {
  newItems: [],
};

export default List;
